export const getSignId = () => {
  return (Date.now() % 100000) + Math.floor(Math.random() * 1000)
}
